<div class="container" [class.shadow-mode]="shadowMode">
  <svg id="first" width="100%" height="100%">
    <rect x="0" y="0" width="100%" height="100%" fill="none" stroke-width="2" rx="44" stroke-linecap="round" />
  </svg>
  <svg id="second" width="100%" height="100%">
    <rect x="0" y="0" width="100%" height="100%" fill="none" stroke-width="2" rx="48" stroke-linecap="round" />
  </svg>
  <svg id="third" width="100%" height="100%">
    <rect x="0" y="0" width="100%" height="100%" fill="none" stroke-width="2" rx="56" stroke-linecap="round" />
  </svg>
  <ng-content></ng-content>
</div>
